module.exports = __webpack_public_path__ + "static/media/17_avatar.4361d25d.png";